import React, { useState, useEffect } from 'react';
import CommissionHistoryTable from './CommissionHistoryTable';
// import GoalEdit from '../goal/GoalEdit';
import { getSocietes } from '../../flux/actions/societeActions';
import { getUsers } from '../../flux/actions/userActions';
import { getBienTypes } from '../../flux/actions/bienActions';
import { getFormulas, addFormula, verifyFormulaAvailability } from '../../flux/actions/formulaActions';
import { getFormula_instances, addOrEditFormula_instance, changeFormulaInstance, deleteFormula_instance } from '../../flux/actions/formulainstanceActions';
import { getFormula_societe_defaults, addOrEditFormula_societe_default } from '../../flux/actions/formulasocietedefaultActions';
import { getCommission_histories, clearCommission_histories, verifyCommissionBlock } from '../../flux/actions/commissionhistoryActions';
import { addCommission_bulletin } from '../../flux/actions/commissionbulletinActions';
import { Container, Row, Col, Label, Input, Button, CustomInput, FormGroup, InputGroup, InputGroupAddon, InputGroupText, Modal, ModalHeader, ModalBody, Collapse, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import { connect } from 'react-redux';
import { ICommissionContainer, ICommissionReduxProps, ICommission_history, ITarget } from '../../types/interfaces';
import LoadingPage from '../../pages/loading';
import Loading from '../Loading';
import { PRIVILEGE } from '../../types/privileges'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faBoxOpen, faHouseUser, faUserTag, faAngleDoubleDown, faMoneyCheckAlt, faWallet, faBullseye, faExclamationCircle, faCalculator, faEdit, faCircle, faCheck, faTimes, faSearch, faCheckCircle, faSpinner, faPen, faCheckSquare, faAngleDown, faAngleUp, faList, faFolderPlus, faUser, faCaretLeft, faCaretRight, faCommentDots, faCalendarAlt, faTrash, faThumbtack, faCheckDouble, faListUl, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import Durations from '../Durations';
import { E_ERROR } from '../../types/errors';
import { constants } from '../../types/constants';
import { useParams } from "react-router-dom";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import moment from 'moment';
import DatePicker from "reactstrap-date-picker";
// ChartJS.register(ArcElement, Tooltip, Legend);
import { useAlert } from "react-alert";
import ReactTooltip from 'react-tooltip';
import MonthPicker from 'react-month-picker'
import { betterTypeName } from '../../services/formatting';
import { instantPrint } from '../pdf/PDFLink';
import { useBeforeunload } from 'react-beforeunload'
import Construction from '../Construction';
import GoalCardContainer from '../goal_charge/GoalCardContainer';
import { formulaTagsExp, getAvailableVarsComm } from '../../services/misc';
import TableContainer from '../tables_manager/TableContainer';
import CommissionBlockReasonsModal from './CommissionBlockReasonsModal';

const CommissionContainerComponent = ({
  getSocietes,
  getUsers,
  getCommission_histories,
  clearCommission_histories,
  addCommission_bulletin,
  addFormula,
  getFormulas,
  addOrEditFormula_instance,
  deleteFormula_instance,
  addOrEditFormula_societe_default,
  getFormula_instances,
  getFormula_societe_defaults,
  societe,
  user,
  formula,
  formula_instance,
  formula_societe_default,
  commission_history,
  auth
 }: ICommissionContainer) => {
  let { project: projectIdTarget, user: userIdTarget } = useParams();
  const alert = useAlert();

  const { users, loading: loadingU } = user;
  const { societes, loading: loadingS } = societe;
  const { formulas, loading: loadingF } = formula;
  const { formula_instances, loading: loadingFI } = formula_instance;
  const { formula_societe_defaults, loading: loadingFSD } = formula_societe_default;
  const { commission_histories, loading: loadingCH } = commission_history;
  const [commissionsTableData, setCommissionsTableData] = useState(commission_histories);
  const [commissionsTableData2, setCommissionsTableData2] = useState<any[]>([]);
  const [filteredCommissionsRows, setFilteredCommissionsRows] = useState(commission_histories);
  const arList: ICommission_history[] = commissionsTableData.filter(e => !!e.accepted_table || !!e.rejected_table);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [clearFilters, setClearFilters] = useState(false);
  const [clearRowsKey, setClearRowsKey] = useState(0);

  const societeOptions = [{value: {id: "ALL", LIBELE: "Tous les projets"}, label: "Tous les projets"}, ...societes.map(e => ({value: e, label: e.LIBELE}))];
  const societeOptionsWithNoAll = societes.map(e => ({value: e, label: e.LIBELE}));
  const [societeValue, setSocieteValue] = useState<any>(societeOptions.find(e => e.value.id === "ALL")?.value);
  const [filterUsers, setFilterUsers] = useState(false);
  const userOptions = (auth?.user?.privileges?.includes(PRIVILEGE.OTHERS_COMMISSIONS) ? [{id: "ALL", LOGIN: "Tous les commerciaux"}, ...users.map(e => ({id: e.id, LOGIN: e.username, speciality: e.speciality, worksatProjects: e.worksatProjects}))] : [{id: auth?.user?.id, LOGIN: auth?.user?.username, worksatProjects: auth?.user?.worksatProjects || [], speciality: auth?.user?.speciality}]).filter(e => !(filterUsers && !!auth?.user?.privileges?.includes(PRIVILEGE.OTHERS_COMMISSIONS)) || (e["worksatProjects"] && societeValue && (societeValue.id === "ALL" ? e["worksatProjects"].length : e["worksatProjects"].find(e => e.id === societeValue.id)))).map(e => ({value: e.id, label: `${e["LOGIN"] || e["username"]}${e["speciality"] === constants.ROLE_PROMOTEUR ? " (Prom.)" : e["speciality"] === constants.ROLE_INTERMEDIAIRE ? " (Inter.)" : ""}`, user: e}));
  const [selectedUser, setSelectedUser] = useState<any>(/*userOptions.find(e => e.value === "ALL")?.user || */'');
  const [commissionsFrom, setCommissionsFrom] = useState<any>(undefined);
  const [commissionsTo, setCommissionsTo] = useState<any>(undefined);
  const [noCommissions, setNoCommissions] = useState(false);
  const [validatedCommissions, setValidatedCommissions] = useState(false);
  const CHFiltersOptions = [{value: constants.CH_NULL, label: "Nulles", color: "black"}, {value: constants.CH_NOT_NULL, label: "Non Nulles", color: "black"}, {value: constants.CH_GRAYED, label: "Grisées", color: "grey"}, {value: constants.CH_NOT_GRAYED, label: "Non Grisées", color: "gray"}, {value: constants.CH_REJECTED, label: "Rejetées", color: "tomato"}, {value: constants.CH_NOT_REJECTED, label: "Non Rejetées", color: "tomato"}, {value: constants.CH_VALIDATED, label: "Validées", color: "cornflowerblue"}, {value: constants.CH_NOT_VALIDATED, label: "Non Validées", color: "cornflowerblue"}, {value: constants.CH_PAID, label: "Payées", color: "darkgreen"}, {value: constants.CH_NOT_PAID, label: "Non Payées", color: "darkgreen"}];
  const defaultCHFilters = CHFiltersOptions.filter(e => [constants.CH_NOT_NULL, constants.CH_NOT_GRAYED, constants.CH_NOT_REJECTED, constants.CH_NOT_VALIDATED, constants.CH_NOT_PAID].includes(e.value))
  const [CHFilters, setCHFilters] = useState<any[]>(defaultCHFilters)
  const [moreSettings, setMoreSettings] = useState(false);
  const formulaTags = formulaTagsExp.map(e => ({
    ...e,
    tag: <div className="cardSticker" style={{backgroundColor: e.color, margin: 0, marginLeft: "4px"}} onMouseOver={() => setHighlightTag(e.id)} onMouseOut={() => setHighlightTag(undefined)}>{e.name}</div>
  }));

  const formatFormula = e => {
    const availableVars = getAvailableVarsComm(e)
    return {
      id: e.id,
      name: e.name,
      content: <div className="formulaTagsContainer">
        {availableVars.map((t, key, arr) => <>
          <div className="formulaTagsEach">{t.o === 'p' ? <div><b style={t.n < 0 ? {color: "darkred"} : {}}>{t.n}%</b> ×</div> : <div><b style={t.n < 0 ? {color: "darkred"} : {}}>{t.n.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH</b> pour chaque</div>}{formulaTags.find(e => e.id === t.v)?.tag || null}</div>
          {!!(key < arr.length - 1) && <FontAwesomeIcon icon={faPlus} className="formulaTagsPlus" />}
        </>)}
      </div>
    }
  }
  const formulasData = formulas.map(e => formatFormula(e))
  const [selectedFormula, setSelectedFormula] = useState<any>(undefined);
  const [formulasModal, setFormulasModal] = useState(false);
  const [CHModal, setCHModal] = useState(false);
  const [isVerifyingFA, setIsVerifyingFA] = useState(false);
  const [highlightTag, setHighlightTag] = useState<any>(undefined);
  const [userFormulasOpen, setUserFormulasOpen] = useState(true);
  const [isChangeFormulaOpen, setIsChangeFormulaOpen] = useState(false);
  const [isCreateFormulaOpen, setIsCreateFormulaOpen] = useState(false);
  const [formulaName, setFormulaName] = useState('');
  const [formulaNameAuto, setFormulaNameAuto] = useState(true);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [disableSubmitCH, setDisableSubmitCH] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  const [reEnableCH, setReEnableCH] = useState(false);
  const formulaVarsOptions = formulaTags.map(e => ({value: e, label: e.description}));
  const formulaNumberOperatorsOptions = [{value: 'p', label: "%"}, {value: 'f', label: "Forfait"}];
  const [comFormulas, setComFormulas] = useState<any[]>([]);
  const [typesVenteOptions, setTypesVenteOptions] = useState<any[]>([]);
  const [typesVenteValues, setTypesVenteValues] = useState<any[]>(typesVenteOptions);
  const [societeFormulaValue, setSocieteFormulaValue] = useState<any>('');
  const [societeFormulaCreateValue, setSocieteFormulaCreateValue] = useState<any>(societeOptions.find(e => e.value.id === "ALL")?.value);
  const formulaTargetOptions = [{value: "USER", label: `Le commercial ${selectedUser?.LOGIN || ""}`}, {value: "ALL", label: societeFormulaCreateValue?.id !== "ALL" ? `Tout le projet ${societeFormulaCreateValue?.LIBELE}` : societeFormulaCreateValue?.LIBELE}];
  const [formulaTarget, setFormulaTarget] = useState<any>(formulaTargetOptions.find(e => e.value === "USER"));
  const [bonusMalusValue, setBonusMalusValue] = useState(0);
  const [commentCHValue, setCommentCHValue] = useState('');
  const today = new Date();
  const [yearValue, setYearValue] = useState<any>(today.getFullYear());
  const [monthPickerValue, setMonthPickerValue] = useState({ year: today.getFullYear(), month: today.getMonth() + 1 });
  const [monthManuallyChanged, setMonthManuallyChanged] = useState(false);
  const monthPickerRef = React.useRef<any>(null);
  const [selectedDuration, setSelectedDuration] = useState<any>('');
  const [FILoading, setFILoading] = useState(false);
  const [showFormulaTarget, setShowFormulaTarget] = useState(false);
  const [showSocieteWrite, setShowSocieteWrite] = useState(false);
  const [showTypesVente, setShowTypesVente] = useState(false);
  const [isDeleting, setIsDeleting] = useState<number[]>([]);
  const [tagsArePinned, setTagsArePinned] = useState(true);
  const defaultFormulaEntries = {
    1: {
      formulaNumber: .5,
      formulaNumberOperator: 'p',
      formulaVar: formulaVarsOptions.find(e => e.value.id === constants.COMMISSION_ER_ID)?.value
    },
    2: {
      formulaNumber: -.5,
      formulaNumberOperator: 'p',
      formulaVar: formulaVarsOptions.find(e => e.value.id === constants.COMMISSION_EImpaye_ID)?.value
    },
    3: {
      formulaNumber: -1,
      formulaNumberOperator: 'p',
      formulaVar: formulaVarsOptions.find(e => e.value.id === constants.COMMISSION_EInactif_ID)?.value
    },
    4: {
      formulaNumber: -1,
      formulaNumberOperator: 'p',
      formulaVar: formulaVarsOptions.find(e => e.value.id === constants.COMMISSION_EImpayeInactif_ID)?.value
    },
  };
  const [formulaEntries, setFormulaEntries] = useState<any>(defaultFormulaEntries);
  const [activeTab, setActiveTab] = useState(constants.TAB_OBJECTIF);

  const [blockCommission, setBlockCommission] = useState(false)
  const [blockCommissionReasons, setBlockCommissionReasons] = useState<any>(undefined)
  const [blockCommissionReasonsSearchText, setBlockCommissionReasonsSearchText] = useState('')
  const [blockCommissionLoading, setBlockCommissionLoading] = useState(false)
  const [blockCommissionReasonsModal, setBlockCommissionReasonsModal] = useState(false)

  const handleToggleFormulas = () => setFormulasModal(!formulasModal);
  const handleToggleCH = () => setCHModal(!CHModal);

  const modalClosedHandleFormulas = () => {
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };
  
  const showMonthPicker = () => {
    if(monthPickerRef?.current)
      monthPickerRef.current.show()
  };

  const handlePickerChange = (year, month) => {
    setMonthManuallyChanged(true)
    setMonthPickerValue({ year, month });
    if(monthPickerRef?.current)
      monthPickerRef.current.dismiss()
  };

  const modalClosedHandleCH = () => {
    if(reEnableCH){
      setDisableSubmitCH(false);
      setReEnableCH(false);
    }
  };

  const handleSocieteFormulaChange = data => {
    setSocieteFormulaValue(data ? data.value : '');
  }
  const handleSocieteFormulaCreateChange = data => {
    setSocieteFormulaCreateValue(data ? data.value : '');
  }
  const handleTypesVenteChange = data => {
    setTypesVenteValues(data?.length ? data : []);
  }
  const formulaNameChangeHandler = (e: ITarget) => {
    setFormulaName(e.target.value);
    setFormulaNameAuto(false);
  }
  const handleFormulaTargetChange = data => {
    setFormulaTarget(data || '');
  }
  const commentCHChangeHandler = (e: ITarget) => setCommentCHValue(e.target.value);

  useBeforeunload((e) => {
    // if(selectedRows?.length)
    if(arList?.length)
      e.preventDefault();
  });

  useEffect(() => {
    if(auth?.user?.societes?.length)
      for(let e of auth.user.societes)
        if(e.id == auth.user.last_societe){
          setSocieteValue(e);
          break
        }
  }, [auth?.user?.societes]);

  useEffect(() => {
    if(formulaTarget?.value !== "ALL")
      setFormulaTarget(e => ({...e, label: `Le commercial ${selectedUser?.LOGIN || ""}`}))
    else
      setFormulaTarget(e => ({...e, label: societeFormulaCreateValue?.id !== "ALL" ? `Tout le projet ${societeFormulaCreateValue?.LIBELE}` : societeFormulaCreateValue?.LIBELE}))
  }, [selectedUser, societeFormulaCreateValue])

  useEffect(() => {
    getBienTypes(societeFormulaCreateValue?.id).then(e => {
      if(e?.types){
        const options = [...e.types, ...(/*e.projectHasAssociations*/false ? ["ass-m", "ass-a"] : [])].map(e => ({value: e, label: betterTypeName(e)}))
        setTypesVenteOptions(options)
        setTypesVenteValues(options)
      }
    })
  }, [societeFormulaCreateValue])

  useEffect(() => {
    if(!isChangeFormulaOpen || !showSocieteWrite)
      setSocieteFormulaCreateValue(societeFormulaValue)
  }, [societeFormulaValue])

  useEffect(() => {
    if(formulaNameAuto)
      setFormulaName(`${formulaTarget?.value !== "ALL" ? (selectedUser?.LOGIN || "") : "Tout"}${societeFormulaCreateValue?.LIBELE && societeFormulaCreateValue?.id !== "ALL" ? ` ${societeFormulaCreateValue.LIBELE}` : ""}${typesVenteValues.length !== typesVenteOptions.length ? ` ${typesVenteValues.map(e => e.label).join("-")}` : ""}`)
  }, [formulaNameAuto, selectedUser, formulaTarget, societeFormulaCreateValue, typesVenteValues])

  useEffect(() => {
    if(selectedUser && societeFormulaValue/* && !loadingFI && !loadingFSD*/){
      const societeDefaultTemp = formula_societe_defaults.find(e => e.societeId === societeFormulaValue?.id);
      let instancesTemp: any[] = formula_instances.filter(e => e.comId === selectedUser?.id && e.societeId === societeFormulaValue?.id);
      if(formula_instances.find(e => e.comId === null && e.societeId === societeFormulaValue?.id)){
        const instancesNoComTemp = formula_instances.filter(e => e.comId === null && e.societeId === societeFormulaValue?.id)
        for(let i in instancesNoComTemp)
          if(instancesTemp.every(e => e.typeVente !== instancesNoComTemp[i].typeVente))
            instancesTemp.push(instancesNoComTemp[i])
      }
      instancesTemp = instancesTemp.map(e => e.usingDefault ? {...e, formulaId: societeDefaultTemp?.formulaId} : e);
      let addDefault = true;
      if(societeDefaultTemp){
        if(instancesTemp.find(e => !e.typeVente/* && e.formulaId === societeDefaultTemp.formulaId*/))
          addDefault = false
      }
      setComFormulas([...(addDefault && societeDefaultTemp ? [{...societeDefaultTemp, typeVente: null, isFromSD: true}] : []), ...instancesTemp].map(e => ({id: e.id, formula: formulasData.find(t => t.id === e.formulaId), comId: e.comId, type: e.typeVente, societeId: e.societeId, isFromSD: !!e["isFromSD"]})))
    }
    else
      setComFormulas([])
  }, [selectedUser, societeFormulaValue, formula_instances, formula_societe_defaults])

  const changeNoCommissionsHandle = (e) => {
    setNoCommissions(e.target.checked);
  };

  const changeValidatedCommissionsHandle = (e) => {
    setValidatedCommissions(e.target.checked);
  };

  const handleCHFiltersChange = (data, {action, removedValue}) => {
    let newData = data || []
    const autoInsert = (e, t) => {
      if([e, t].includes(removedValue?.value)){
        if(data.every(n => ![e, t].includes(n.value))){
          if(removedValue?.value === e)
            newData.push(CHFiltersOptions.find(n => n.value === t))
          else
            newData.push(CHFiltersOptions.find(n => n.value === e))
        }
      }
    }
    if(action === "remove-value"){
      autoInsert(constants.CH_NULL, constants.CH_NOT_NULL)
      autoInsert(constants.CH_GRAYED, constants.CH_NOT_GRAYED)
      autoInsert(constants.CH_REJECTED, constants.CH_NOT_REJECTED)
      autoInsert(constants.CH_VALIDATED, constants.CH_NOT_VALIDATED)
      autoInsert(constants.CH_PAID, constants.CH_NOT_PAID)
    }
    // else if(action === "clear")
    //   newData = defaultCHFilters
    setCHFiltersAndSort(newData)
  }

  const setCHFiltersAndSort = e => setCHFilters(e.sort((e, t) => CHFiltersOptions.findIndex(n => n.value === e.value) - CHFiltersOptions.findIndex(n => n.value === t.value)))

  const setDefaultCHFilters = () => setCHFiltersAndSort(defaultCHFilters)
  const setAllCHFilters = () => setCHFiltersAndSort(CHFiltersOptions)

  useEffect(() => {
    getFormulas();
  }, [getFormulas])

  useEffect(() => {
    if(selectedUser)
      getFormula_instances(selectedUser?.id);
  }, [getFormula_instances, selectedUser])

  useEffect(() => {
    getFormula_societe_defaults();
  }, [getFormula_societe_defaults])

  useEffect(() => {
    setCommissionsTableData(commission_histories?.map(e => {
      // let isDangerRow = false
      // let filteredType = e.type
      // let isTRA = false
      // let isDES = false
      // if(e.type){
      //   if(e.type.includes("TRA_")){
      //     filteredType = e.type.replace("TRA_", "")
      //     isTRA = true
      //   }
      //   else if(e.type.includes("DES_")){
      //     filteredType = e.type.replace("DES_", "")
      //     isDES = true
      //   }
      // }
      // if(["VU", "VA", "VAD", "VP", "L", "SC", "CN"].includes(filteredType) && e.commission > 1){
      //   isDangerRow = true
      //   const VETemp = e.contrat?.contrat_encaissements || []
      //   for(let i in VETemp)
      //     if(VETemp[i].encaissement?.STATUT && ![constants.STATUT_ENC_A_NE_PAS_VERSER_NR, constants.STATUT_ENC_A_NE_PAS_VERSER_R, constants.STATUT_ENC_A_RECUPERER, constants.STATUT_ENC_IMPAYE, constants.STATUT_ENC_DEFAULT].includes(VETemp[i].encaissement?.STATUT || "")){
      //       isDangerRow = false
      //       break
      //     }
      // }
      return e.accepted_table = commissionsTableData.find(t => t.id === e.id)?.accepted_table || false, e.rejected_table = commissionsTableData.find(t => t.id === e.id)?.rejected_table || false, e.QTE_INIT_TABLE = e.commission, e.bonus_malus_table = e.initialBonus, e.isDangerRow = !!e.badEnc || e.rejected === 1, e
    }) || [])
    // setCommissionsTableData(commission_histories?.filter(e => {
    //   if(!CHFilters.find(e => e.value === constants.CH_NULL) && !CHFilters.find(e => e.value === constants.CH_NOT_NULL))
    //     return false
      
    //   if(!CHFilters.find(e => e.value === constants.CH_NULL) || !CHFilters.find(e => e.value === constants.CH_NOT_NULL)){
    //     if(CHFilters.find(e => e.value === constants.CH_NOT_NULL))
    //       return e.commission_init !== 0
    //     else if(CHFilters.find(e => e.value === constants.CH_NULL))
    //       return e.commission_init === 0
    //   }
    //   return true
    // }).filter(e => {
    //   if(!CHFilters.find(e => e.value === constants.CH_GRAYED) && !CHFilters.find(e => e.value === constants.CH_NOT_GRAYED))
    //     return false
      
    //   if(!CHFilters.find(e => e.value === constants.CH_GRAYED) || !CHFilters.find(e => e.value === constants.CH_NOT_GRAYED)){
    //     if(CHFilters.find(e => e.value === constants.CH_NOT_GRAYED))
    //       return e.grayedOut !== 1
    //     else if(CHFilters.find(e => e.value === constants.CH_GRAYED))
    //       return e.grayedOut === 1
    //   }
    //   return true
    // }).filter(e => {
    //   if(!CHFilters.find(e => e.value === constants.CH_REJECTED) && !CHFilters.find(e => e.value === constants.CH_NOT_REJECTED))
    //     return false
      
    //   if(!CHFilters.find(e => e.value === constants.CH_REJECTED) || !CHFilters.find(e => e.value === constants.CH_NOT_REJECTED)){
    //     if(CHFilters.find(e => e.value === constants.CH_NOT_REJECTED))
    //       return e.rejected !== 1
    //     else if(CHFilters.find(e => e.value === constants.CH_REJECTED))
    //       return e.rejected === 1
    //   }
    //   return true
    // })/*.filter(e => {
    //   if(!CHFilters.find(e => e.value === constants.CH_VALIDATED) && !CHFilters.find(e => e.value === constants.CH_NOT_VALIDATED))
    //     return false
      
    //   if(!CHFilters.find(e => e.value === constants.CH_VALIDATED) || !CHFilters.find(e => e.value === constants.CH_NOT_VALIDATED)){
    //     if(CHFilters.find(e => e.value === constants.CH_NOT_VALIDATED))
    //       return !e.commission_bulletin_lines || e.commission_bulletin_lines.length === 0
    //     else if(CHFilters.find(e => e.value === constants.CH_VALIDATED))
    //       return e.commission_bulletin_lines && e.commission_bulletin_lines.length !== 0
    //   }
    //   return true
    // }).filter(e => {
    //   if(!CHFilters.find(e => e.value === constants.CH_PAID) && !CHFilters.find(e => e.value === constants.CH_NOT_PAID))
    //     return false
      
    //   if(!CHFilters.find(e => e.value === constants.CH_PAID) || !CHFilters.find(e => e.value === constants.CH_NOT_PAID)){
    //     if(CHFilters.find(e => e.value === constants.CH_NOT_PAID))
    //       return !e.commission_bulletin_lines || e.commission_bulletin_lines.length === 0 || e.commission_bulletin_lines.every(e => !e.commission_bulletin || e.commission_bulletin.paid === 0)
    //     else if(CHFilters.find(e => e.value === constants.CH_PAID))
    //       return e.commission_bulletin_lines && e.commission_bulletin_lines.length !== 0 && e.commission_bulletin_lines.every(e => e.commission_bulletin && e.commission_bulletin.paid !== 0)
    //   }
    //   return true
    // })*/.filter(e => {
    //   if(!CHFilters.find(e => e.value === constants.CH_VALIDATED) && !CHFilters.find(e => e.value === constants.CH_NOT_VALIDATED))
    //     return false
      
    //   if(!CHFilters.find(e => e.value === constants.CH_VALIDATED) || !CHFilters.find(e => e.value === constants.CH_NOT_VALIDATED)){
    //     if(CHFilters.find(e => e.value === constants.CH_NOT_VALIDATED))
    //       return e.commission !== 0 || e.commission_init === 0
    //     else if(CHFilters.find(e => e.value === constants.CH_VALIDATED))
    //       return e.commission === 0 && e.commission_init !== 0
    //   }
    //   return true
    // }).filter(e => {
    //   if(!CHFilters.find(e => e.value === constants.CH_PAID) && !CHFilters.find(e => e.value === constants.CH_NOT_PAID))
    //     return false
      
    //   if(!CHFilters.find(e => e.value === constants.CH_PAID) || !CHFilters.find(e => e.value === constants.CH_NOT_PAID)){
    //     if(CHFilters.find(e => e.value === constants.CH_NOT_PAID))
    //       return e.commission !== 0 || e.commission_init === 0 || e.commission_bulletin_lines?.every(e => !e.commission_bulletin || e.commission_bulletin.paid === 0)
    //     else if(CHFilters.find(e => e.value === constants.CH_PAID))
    //       return e.commission === 0 && e.commission_init !== 0 && e.commission_bulletin_lines?.every(e => e.commission_bulletin && e.commission_bulletin.paid !== 0)
    //   }
    //   return true
    // }).filter(e => /*(validatedCommissions ? (noCommissions ? true : e.commission_init !== 0) : (noCommissions ? ((e.commission > 0 || e.commission < 0) || e.commission_init === 0) : (e.commission > 0 || e.commission < 0))) &&*/ (selectedUser?.id === "ALL" || e.comId === selectedUser?.id)).map(e => {
    //   let isDangerRow = false
    //   let filteredType = e.type
    //   let isTRA = false
    //   let isDES = false
    //   if(e.type){
    //     if(e.type.includes("TRA_")){
    //       filteredType = e.type.replace("TRA_", "")
    //       isTRA = true
    //     }
    //     else if(e.type.includes("DES_")){
    //       filteredType = e.type.replace("DES_", "")
    //       isDES = true
    //     }
    //   }
    //   if(["VU", "VA", "VAD", "VP", "L", "SC", "CN"].includes(filteredType) && e.commission > 1){
    //     isDangerRow = true
    //     const VETemp = e.contrat?.contrat_encaissements || []
    //     for(let i in VETemp)
    //       if(VETemp[i].encaissement?.STATUT && ![constants.STATUT_ENC_A_NE_PAS_VERSER_NR, constants.STATUT_ENC_A_NE_PAS_VERSER_R, constants.STATUT_ENC_A_RECUPERER, constants.STATUT_ENC_IMPAYE, constants.STATUT_ENC_DEFAULT].includes(VETemp[i].encaissement?.STATUT || "")){
    //         isDangerRow = false
    //         break
    //       }
    //   }
    //   return e.accepted_table = commissionsTableData.find(t => t.id === e.id)?.accepted_table || false, e.rejected_table = commissionsTableData.find(t => t.id === e.id)?.rejected_table || false, e.QTE_INIT_TABLE = e.commission, e.bonus_malus_table = e.initialBonus, e.isDangerRow = !!e.badEnc || e.rejected === 1, e
    // }) || []);
    setCommissionsTableData2(commission_histories?.filter(e => {
      if(!CHFilters.find(e => e.value === constants.CH_NULL) && !CHFilters.find(e => e.value === constants.CH_NOT_NULL))
        return false
      
      if(!CHFilters.find(e => e.value === constants.CH_NULL) || !CHFilters.find(e => e.value === constants.CH_NOT_NULL)){
        if(CHFilters.find(e => e.value === constants.CH_NOT_NULL))
          return e.commission_init !== 0
        else if(CHFilters.find(e => e.value === constants.CH_NULL))
          return e.commission_init === 0
      }
      return true
    }).filter(e => {
      if(!CHFilters.find(e => e.value === constants.CH_GRAYED) && !CHFilters.find(e => e.value === constants.CH_NOT_GRAYED))
        return false
      
      if(!CHFilters.find(e => e.value === constants.CH_GRAYED) || !CHFilters.find(e => e.value === constants.CH_NOT_GRAYED)){
        if(CHFilters.find(e => e.value === constants.CH_NOT_GRAYED))
          return e.grayedOut !== 1
        else if(CHFilters.find(e => e.value === constants.CH_GRAYED))
          return e.grayedOut === 1
      }
      return true
    }).filter(e => {
      if(!CHFilters.find(e => e.value === constants.CH_REJECTED) && !CHFilters.find(e => e.value === constants.CH_NOT_REJECTED))
        return false
      
      if(!CHFilters.find(e => e.value === constants.CH_REJECTED) || !CHFilters.find(e => e.value === constants.CH_NOT_REJECTED)){
        if(CHFilters.find(e => e.value === constants.CH_NOT_REJECTED))
          return e.rejected !== 1
        else if(CHFilters.find(e => e.value === constants.CH_REJECTED))
          return e.rejected === 1
      }
      return true
    }).filter(e => {
      return e.commission_init !== 0 && e.commission !== e.commission_init
    })/*.filter(e => {
      if(!CHFilters.find(e => e.value === constants.CH_PAID) && !CHFilters.find(e => e.value === constants.CH_NOT_PAID))
        return false
      
      if(!CHFilters.find(e => e.value === constants.CH_PAID) || !CHFilters.find(e => e.value === constants.CH_NOT_PAID)){
        if(CHFilters.find(e => e.value === constants.CH_NOT_PAID))
          return e.commission !== 0 || e.commission_init === 0 || e.commission_bulletin_lines?.every(e => !e.commission_bulletin || e.commission_bulletin.paid === 0)
        else if(CHFilters.find(e => e.value === constants.CH_PAID))
          return e.commission === 0 && e.commission_init !== 0 && e.commission_bulletin_lines?.every(e => e.commission_bulletin && e.commission_bulletin.paid !== 0)
      }
      return true
    })*/.filter(e => /*(validatedCommissions ? (noCommissions ? true : e.commission_init !== 0) : (noCommissions ? ((e.commission > 0 || e.commission < 0) || e.commission_init === 0) : (e.commission > 0 || e.commission < 0))) &&*/ (selectedUser?.id === "ALL" || e.comId === selectedUser?.id)).map(e => {
      let isDangerRow = false
      let filteredType = e.type
      let isTRA = false
      let isDES = false
      if(e.type){
        if(e.type.includes("TRA_")){
          filteredType = e.type.replace("TRA_", "")
          isTRA = true
        }
        else if(e.type.includes("DES_")){
          filteredType = e.type.replace("DES_", "")
          isDES = true
        }
      }
      if(["VU", "VA", "VAD", "VP", "L", "SC", "CN"].includes(filteredType) && e.commission > 1){
        isDangerRow = true
        const VETemp = e.contrat?.contrat_encaissements || []
        for(let i in VETemp)
          if(VETemp[i].encaissement?.STATUT && ![constants.STATUT_ENC_A_NE_PAS_VERSER_NR, constants.STATUT_ENC_A_NE_PAS_VERSER_R, constants.STATUT_ENC_A_RECUPERER, constants.STATUT_ENC_IMPAYE, constants.STATUT_ENC_DEFAULT].includes(VETemp[i].encaissement?.STATUT || "")){
            isDangerRow = false
            break
          }
      }
      return e.accepted_table = commissionsTableData2.find(t => t.id === e.id)?.accepted_table || false, e.rejected_table = commissionsTableData2.find(t => t.id === e.id)?.rejected_table || false, e.QTE_INIT_TABLE = e.commission, e.bonus_malus_table = e.initialBonus, e.isDangerRow = !!e.badEnc || e.rejected === 1, e
    }) || []);
  }, [commission_histories])

  // useEffect(() => {
  //   setCommission(commission_histories?.filter(e => !e.commissioned && e.comId === selectedUser?.id).reduce((e, t) => e + (t.commission || 0), 0) || 0)
  // }, [commission_histories])

  useEffect(() => {
    auth && auth.user && getSocietes(auth?.user.societes?.map(e => e.id) || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
  }, [getSocietes, auth]);

  // useEffect(() => {
  //   if(auth?.user?.id !== undefined && selectedUser === '')
  //     setSelectedUser(userOptions.find(e => e.user.id === auth.user.id)?.user || '')
  // }, [auth?.user?.id, userOptions]);

  useEffect(() => {
    if(selectedUser === ''){
      let choosenId: any = undefined;
      if(userIdTarget !== undefined)
        choosenId = userIdTarget
      else if(auth?.user?.id !== undefined){
        if(!auth?.user?.privileges?.includes(PRIVILEGE.OTHERS_COMMISSIONS))
          choosenId = auth.user.id
      }
      if(choosenId !== undefined)
        setSelectedUser((choosenId == -1 ? (/*auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? userOptions.find(e => e.value === "ALL")?.user : */undefined) : userOptions.find(e => e.user.id == choosenId)?.user) || '')
    }
  }, [auth?.user, userOptions]);

  useEffect(() => {
    if(monthManuallyChanged)
      setCommissionsFrom(selectedDuration?.from?.add(2, "hours").toISOString())
    else
      setCommissionsFrom(new Date(2022, 0, 1, 2).toISOString())
    setCommissionsTo(selectedDuration?.to?.toISOString())
  }, [selectedDuration])

  useEffect(() => {
    setSelectedDuration({
      from: moment({month: monthPickerValue.month - 1, year: monthPickerValue.year}).startOf('month'),
      to: moment({month: monthPickerValue.month - 1, year: monthPickerValue.year}).endOf('month'),
      isCustom: true
    });
  }, [monthPickerValue])

  useEffect(() => {
    if(societeValue && societeValue?.id !== "ALL")
      setSocieteFormulaValue(societeValue)
  }, [societeValue])

  useEffect(() => {
    if(!societeFormulaValue && societes && societes.length){
      if(auth && auth.user){
        for(let so of societes)
          if(so.id == auth.user.last_societe){
            setSocieteFormulaValue(so);
            break
          }
      }
    }
  }, [societes]);

  const refreshData = () => {
    clearCommission_histories();
    if(commissionsFrom && commissionsTo && societeValue && auth?.user && selectedUser && !loadingU)
      getCommission_histories({
        from: commissionsFrom,
        to: commissionsTo,
        isCustom: true
      }, selectedUser.id, societeValue["id"], CHFilters?.map(e => e.value).filter(e => [constants.CH_NULL, constants.CH_NOT_NULL].includes(e)), CHFilters?.map(e => e.value).filter(e => [constants.CH_GRAYED, constants.CH_NOT_GRAYED].includes(e)), CHFilters?.map(e => e.value).filter(e => [constants.CH_REJECTED, constants.CH_NOT_REJECTED].includes(e)), CHFilters?.map(e => e.value).filter(e => [constants.CH_VALIDATED, constants.CH_NOT_VALIDATED].includes(e)), CHFilters?.map(e => e.value).filter(e => [constants.CH_PAID, constants.CH_NOT_PAID].includes(e))/*, noCommissions ? 1 : 0, validatedCommissions ? 1 : 0*/)
  }
  
  useEffect(() => {
    refreshData()
  }, [commissionsFrom, commissionsTo, societeValue, selectedUser, noCommissions, validatedCommissions, CHFilters, auth, loadingU])

  useEffect(() => {
    return () => {
      clearCommission_histories();
    }
  }, []);

  const callbackDeleteFI = (success) => {
    if(success){
      // if(isDeleting === undefined || isDeleting === success)
        setIsDeleting(e => e.filter(e => e !== success));
      alert.success("Méthode détachée avec succès");
      return
    }
    alert.error("Une erreur s'est produite");
    setIsDeleting([]);
  }

  const deleteFIHandle = e => {
    if(!e || e.isFromSD)
      return
    setIsDeleting(t => [...t, e.id]);
    deleteFormula_instance(e.id, callbackDeleteFI)
  }
  
  const callback = (success, choose) => {
    if(success){
      setReEnable(true);
      setFormulasModal(false);
      if(alert.removeAll && typeof alert.removeAll === "function")
        alert.removeAll()
      alert.success("Méthode de calcul ajoutée");
      setFormulaName('');
      setFormulaNameAuto(true);
      setFormulaEntries(defaultFormulaEntries);
      setUserFormulasOpen(true);
      setIsChangeFormulaOpen(false);
      setIsCreateFormulaOpen(false);
      if(choose)
        changeFormulaInstanceHandle(success.id)
      // refresh();
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const getFormulaNumber = (formulaVarId: string, formulaOperator: string) => {
    const formulaTemp: any = Object.entries(formulaEntries).map(e => e[1]).find((e: any) => e.formulaVar.id === formulaVarId && e.formulaNumberOperator === formulaOperator);
    return formulaTemp?.formulaNumber || null
  }

  const addFormulaHandle = async (choose = false) => {
    let encOptionsCount = 0
    if(getFormulaNumber(constants.COMMISSION_E_ID, 'p') || getFormulaNumber(constants.COMMISSION_E_ID, 'f'))
      encOptionsCount++
    if(getFormulaNumber(constants.COMMISSION_ER_ID, 'p') || getFormulaNumber(constants.COMMISSION_ER_ID, 'f'))
      encOptionsCount++
    if(getFormulaNumber(constants.COMMISSION_EEI_ID, 'p') || getFormulaNumber(constants.COMMISSION_EEI_ID, 'f'))
      encOptionsCount++
    if(getFormulaNumber(constants.COMMISSION_EEncaisse_ID, 'p') || getFormulaNumber(constants.COMMISSION_EEncaisse_ID, 'f'))
      encOptionsCount++
    if(encOptionsCount > 1){
      alert.error("Maximum des commissions des encaissement autorisé est de 1")
      return
    }
    setDisableSubmit(true);
    const resData = await verifyFormulaAvailabilityHandle(true);
    if(!!resData){
      setDisableSubmit(false);
      // alert.error("Veuillez");
      return
    }
    addFormula({
      name: formulaTarget?.value !== "ALL" || !formulaNameAuto ? formulaName : "",
      vente_u_percent: getFormulaNumber(constants.COMMISSION_VU_ID, 'p'),
      vente_u_each: getFormulaNumber(constants.COMMISSION_VU_ID, 'f'),
      vente_a_percent: getFormulaNumber(constants.COMMISSION_VA_ID, 'p'),
      vente_a_each: getFormulaNumber(constants.COMMISSION_VA_ID, 'f'),
      part_percent: getFormulaNumber(constants.COMMISSION_VP_ID, 'p'),
      part_each: getFormulaNumber(constants.COMMISSION_VP_ID, 'f'),
      livraison_percent: getFormulaNumber(constants.COMMISSION_L_ID, 'p'),
      livraison_each: getFormulaNumber(constants.COMMISSION_L_ID, 'f'),
      signature_client_percent: getFormulaNumber(constants.COMMISSION_SC_ID, 'p'),
      signature_client_each: getFormulaNumber(constants.COMMISSION_SC_ID, 'f'),
      chez_notaire_percent: getFormulaNumber(constants.COMMISSION_CN_ID, 'p'),
      chez_notaire_each: getFormulaNumber(constants.COMMISSION_CN_ID, 'f'),
      enc_non_recep_percent: getFormulaNumber(constants.COMMISSION_E_ID, 'p'),
      enc_non_recep_each: getFormulaNumber(constants.COMMISSION_E_ID, 'f'),
      enc_recep_percent: getFormulaNumber(constants.COMMISSION_ER_ID, 'p'),
      enc_recep_each: getFormulaNumber(constants.COMMISSION_ER_ID, 'f'),
      enc_verse_percent: getFormulaNumber(constants.COMMISSION_EEI_ID, 'p'),
      enc_verse_each: getFormulaNumber(constants.COMMISSION_EEI_ID, 'f'),
      enc_encaisse_percent: getFormulaNumber(constants.COMMISSION_EEncaisse_ID, 'p'),
      enc_encaisse_each: getFormulaNumber(constants.COMMISSION_EEncaisse_ID, 'f'),
      enc_impaye_percent: getFormulaNumber(constants.COMMISSION_EImpaye_ID, 'p'),
      enc_impaye_each: getFormulaNumber(constants.COMMISSION_EImpaye_ID, 'f'),
      enc_inactif_percent: getFormulaNumber(constants.COMMISSION_EImpaye_ID, 'p'),
      enc_inactif_each: getFormulaNumber(constants.COMMISSION_EImpaye_ID, 'f'),
      enc_impaye_inactif_percent: getFormulaNumber(constants.COMMISSION_EImpaye_ID, 'p'),
      enc_impaye_inactif_each: getFormulaNumber(constants.COMMISSION_EImpaye_ID, 'f'),
      createdBy: auth?.user?.id
    }, e => callback(e, choose));
  }

  const verifyFormulaAvailabilityHandle = async (validatingFormula = false) => {
    if(Object.entries(formulaEntries).some((e: any) => !e[1].formulaNumber)){
      alert.error("Veuillez saisir un nombre valide");
      return
    }
    if(Object.entries(formulaEntries).some((e: any) => !e[1].formulaVar?.id)){
      alert.error("Veuillez sélectionner une option");
      return
    }
    if(!validatingFormula)
      setIsVerifyingFA(true);
    const res = await verifyFormulaAvailability(
      getFormulaNumber(constants.COMMISSION_VU_ID, 'p'),
      getFormulaNumber(constants.COMMISSION_VU_ID, 'f'),
      getFormulaNumber(constants.COMMISSION_VA_ID, 'p'),
      getFormulaNumber(constants.COMMISSION_VA_ID, 'f'),
      getFormulaNumber(constants.COMMISSION_VP_ID, 'p'),
      getFormulaNumber(constants.COMMISSION_VP_ID, 'f'),
      getFormulaNumber(constants.COMMISSION_L_ID, 'p'),
      getFormulaNumber(constants.COMMISSION_L_ID, 'f'),
      getFormulaNumber(constants.COMMISSION_SC_ID, 'p'),
      getFormulaNumber(constants.COMMISSION_SC_ID, 'f'),
      getFormulaNumber(constants.COMMISSION_CN_ID, 'p'),
      getFormulaNumber(constants.COMMISSION_CN_ID, 'f'),
      getFormulaNumber(constants.COMMISSION_E_ID, 'p'),
      getFormulaNumber(constants.COMMISSION_E_ID, 'f'),
      getFormulaNumber(constants.COMMISSION_ER_ID, 'p'),
      getFormulaNumber(constants.COMMISSION_ER_ID, 'f'),
      getFormulaNumber(constants.COMMISSION_EEI_ID, 'p'),
      getFormulaNumber(constants.COMMISSION_EEI_ID, 'f'),
      getFormulaNumber(constants.COMMISSION_EEncaisse_ID, 'p'),
      getFormulaNumber(constants.COMMISSION_EEncaisse_ID, 'f'),
      getFormulaNumber(constants.COMMISSION_EImpaye_ID, 'p'),
      getFormulaNumber(constants.COMMISSION_EImpaye_ID, 'f'),
      getFormulaNumber(constants.COMMISSION_EInactif_ID, 'p'),
      getFormulaNumber(constants.COMMISSION_EInactif_ID, 'f'),
      getFormulaNumber(constants.COMMISSION_EImpayeInactif_ID, 'p'),
      getFormulaNumber(constants.COMMISSION_EImpayeInactif_ID, 'f'),
    );

    if(res?.data)
      alert.info("Méthode de calcul existante", {customBtn: {callback: () => changeFormulaInstanceHandle(res.data.id), text: "Sélectionner"}})
      // alert.info("Méthode de calcul existante", {customBtn: {callback: () => setSelectedFormula(formulasData.find(e => e.id === res.data.id)), text: "Sélectionner"}})
    else if(!validatingFormula)
      alert.success("Méthode de calcul disponible")
    
    if(!validatingFormula)
      setIsVerifyingFA(false);

    return res?.data
  }

  const fiCallback = (success) => {
    setFILoading(false);
    if(success){
      // setSelectedFormula(formulasData.find(e => e.id === success.id));
      setUserFormulasOpen(true);
      setIsChangeFormulaOpen(false);
      setIsCreateFormulaOpen(false);
      alert.success("Méthode de calcul modifiée");
      return
    }
    // setSelectedFormula(undefined);
    alert.error("Une erreur s'est produite");
  }

  const changeFormulaInstanceHandle = async e => {
    setFILoading(true);
    if(formulaTarget?.value !== "ALL" || typesVenteValues.length !== typesVenteOptions.length)
      addOrEditFormula_instance(formulaTarget?.value !== "ALL" ? selectedUser?.id : null, societeFormulaCreateValue?.id, typesVenteValues.map(e => e.value), typesVenteValues.length === typesVenteOptions.length ? 1 : 0, e, auth?.user?.id, fiCallback)
    else
      addOrEditFormula_societe_default(societeFormulaCreateValue?.id, e, auth?.user?.id, fiCallback)
  }

  const callbackCH = (success, print = false) => {
    if(success?.success){
      setReEnableCH(true);
      setCHModal(false);
      if(alert.removeAll && typeof alert.removeAll === "function")
        alert.removeAll()
      if(success.commission_bulletin)
        alert.success("Commission confirmée", {open: `/bulletin_commission/${success.commission_bulletin.id}`, timeout: 0});
      else
        alert.success("Commissions modifiées");
      // setSelectedRows([]);
      refreshData()
      setClearRowsKey(e => e + 1)
      setCommentCHValue('')
      setBonusMalusValue(0)
      if(success.commission_bulletin){
        instantPrint({
          documentType: "commission",
          data: success.commission_bulletin,
          // data: {encaissements: success.encaissements, encTitle: "Encaissements Réceptionnés", projectName: success.projectName},
          showPreviewWatermark: false,
        });
      }
      // setCommissionsTableData(e => e.map(e => ({...e, accepted_table: false, rejected_table: false})))
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmitCH(false);
  }

  const checkCHHandle = (action) => {
    if(!action){
      alert.error(E_ERROR.NO_ACTION);
      return
    }
    if(action === constants.VALIDATE_CHECK)
      setClearFilters(true)
    // if(!selectedRows?.length){
    if(!arList?.length){
      alert.error("Veuillez sélectionner des commissions à valider");
      return
    }
    if(arList.filter(e => e.commission === 0 || !Number(e.commission)).length){
      alert.error(`${arList.filter(e => e.commission === 0 || !Number(e.commission)).length} commission(s) vide(s)`)
      return
    }
    else if(!arList.every((v, i, a) => i === 0 || v.comId === a[i - 1].comId)){
      alert.error("Veuillez sélectionner des commissions du même commercial");
      return
    }
    if(action === constants.VALIDATE_CHECK){
      setCHModal(true);
      return
    }
    else if(action === constants.VALIDATE_CONFIRM || action === constants.VALIDATE_CONFIRM_AND_PRINT){
      setDisableSubmitCH(true);
      addCommission_bulletin(arList.filter(e => !!e.accepted_table), arList.filter(e => !!e.rejected_table), arList[0].comId/*, selectedUser?.id || -1*/, bonusMalusValue || 0, commentCHValue, auth?.user?.id, callbackCH, action === constants.VALIDATE_CONFIRM_AND_PRINT);
      return
    }
  }
  
  const handleSocieteChange = data => {
    setSocieteValue(data ? data.value : '');
  }
  const handleUserChange = data => {
    setSelectedUser(data ? data.user : '');
  }

  const filterUsersChangeHandler = e => {
    setFilterUsers(e.target.checked);
  };

  const focusHandler = (e) => {
    if(e.target.value == "0")
      e.target.select();
  };

  const filterOptions = (e, input) => {
    if(!e.value)
      return false;
    const filterWords = input.trim().split(' ');
    
    if(filterWords.length){
      let allWordsMatch = true;
      for(let word of filterWords){
        word = word.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        if(!e.value.LIBELE || !e.value.LIBELE.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(word))
          allWordsMatch = false
      }
      return allWordsMatch
    }
    
    return true;
  }

  useEffect(() => {
    if(selectedUser && !userOptions.find(e => e.user?.id === selectedUser.id))
      setSelectedUser('')
  }, [userOptions])

  useEffect(() => {
    setBlockCommissionReasons(undefined)
    if(!selectedUser?.id || selectedUser.id === "ALL"){
      setBlockCommission(true)
      setBlockCommissionLoading(false)
    }
    else{
          // setBlockCommission(true)
          // setBlockCommissionReasons({})
          // return
      setBlockCommissionLoading(true)
      verifyCommissionBlock(selectedUser.id).then(e => {
        if(e.block){
          setBlockCommission(true)
          setBlockCommissionReasons(e.blockReasons)
          alert.error(e.blockReason || "Commission bloquée pour ce commercial")
        }
        else{
          setBlockCommission(false)
          setBlockCommissionReasons(undefined)
        }
      }).finally(() => setBlockCommissionLoading(false))
    }
  }, [selectedUser])

  return !auth?.user ? <LoadingPage/> : (
    <>
      <Container>
        <Row>
          <Col xs="12" lg="6"><h4 className="title"><FontAwesomeIcon icon={faCalculator} />&nbsp;&nbsp;Gestion des Commissions</h4></Col>
          <Col xs="12" md="6" lg="3" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="societe">Projet : </Label>
            </div>
            <Select
              name="reactselect"
              className="reactselect"
              classNamePrefix="react-select"
              id="societe"
              value={societeValue ? {label: societeValue["LIBELE"], value: societeValue} : null}
              onChange={handleSocieteChange}
              placeholder={'Chercher par projet...'}
              isClearable={true}
              isLoading={loadingS}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              labelKey='LIBELE'
              // valueKey='code'
              options={societeOptions}
              filterOption={filterOptions}
            />
          </Col>
          <Col xs="12" md="6" lg="3" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="user">Commercial : </Label>
            </div>
            <Select
              name="user"
              className="reactselect"
              classNamePrefix="react-select"
              value={selectedUser ? {label: `${selectedUser["LOGIN"] || selectedUser["username"]}${selectedUser.speciality === constants.ROLE_PROMOTEUR ? " (Prom.)" : selectedUser.speciality === constants.ROLE_INTERMEDIAIRE ? " (Inter.)" : ""}`, value: selectedUser.id, user: selectedUser} : null}
              onChange={handleUserChange}
              placeholder={'Chercher par nom...'}
              isClearable={false}
              isLoading={loadingU}
              isDisabled={loadingCH || blockCommissionLoading}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              // labelKey='LOGIN'
              // valueKey='countryCode'
              options={userOptions}
            />
          </Col>
        </Row>
        {!!auth?.user?.privileges?.includes(PRIVILEGE.OTHERS_COMMISSIONS) && <Row className="justify-content-end" style={{marginBottom: "5px"}}>
          <FormGroup check>
            <Input type="checkbox" id="filterUsers" checked={filterUsers} onChange={filterUsersChangeHandler} />
            <Label for="filterUsers" check>Filtrer les commerciaux</Label>
          </FormGroup>
        </Row>}
      </Container>
      <Container>
        <Row>
          <Col xs="12" className="text-center">
            <h5 style={{letterSpacing: "5px", fontFamily: "'Ultra', sans-serif"}}>COMMISSION</h5>
          </Col>
          <Col xs="12" className="text-center">
            <h6 className="fullFlexCenter" style={{letterSpacing: "5px", fontFamily: "'Ultra', sans-serif"}}>
              {selectedUser ? userOptions.find(e => e.value === selectedUser.id)?.label : " "}
              {/* {!!durationDates && ` - ${durationDates}`} */}
              &nbsp;-&nbsp;
              <MonthPicker
                ref={monthPickerRef}
                // years={[2008, 2011, 2012, 2014, 2016, 2018, 2020]}
                years={{min: 2010, max: 2069}}
                value={monthPickerValue}
                key={JSON.stringify(monthPickerValue)}
                lang={constants.MONTHS_ABBRV}
                onChange={handlePickerChange} >
                <div style={{cursor: "pointer"}} onClick={showMonthPicker} title="Changer la date">{constants.DP_MONTHS[monthPickerValue.month - 1]}&nbsp;{monthPickerValue.year}&nbsp;<FontAwesomeIcon icon={faCalendarAlt} /></div>
              </MonthPicker>
            </h6>
          </Col>
          <Col xs="12" className="text-center fullFlexCenter">
            <h1 className="title" style={loadingCH ? {color: "#aaa"} : {}}>{(commissionsTableData?.reduce((e, t) => e + (t.commission_init || 0), 0) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</h1>{((!!auth?.user?.privileges?.includes(PRIVILEGE.SEE_COMMISSIONS_FORMULAS) || !!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_COMMISSIONS_FORMULAS)) && selectedUser?.id !== "ALL") && <>&nbsp;<FontAwesomeIcon icon={faEdit} style={{fontSize: "small", cursor: "pointer"}} title="Modifier la méthode de calcul de la commission" onClick={() => setFormulasModal(true)} /></>}
          </Col>
          {/* {!!(auth?.user?.id === 8 || auth?.user?.id === 34) && <Col xs="12" className="text-center fullFlexCenter">
            <h1 className="title" style={{fontSize: "medium"}}>Validées non payées: {(commissionsTableData2?.reduce((e, t) => e + (t.commission_bulletin_lines?.reduce((e, t) => e + Number((t.commission_bulletin?.paid ? 0 : t.commission) || 0), 0) || 0), 0) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</h1>
          </Col>} */}
          {!!((blockCommission || blockCommissionLoading) && selectedUser) && <Col xs="12" className="text-center fullFlexCenter">
            <h3 className="fullFlexCenter" style={{fontSize: blockCommissionLoading ? "medium" : "large", color: "red"}}>{blockCommissionLoading ? "Vérification..." : <>Commission bloquée,&nbsp;<div onClick={() => setBlockCommissionReasonsModal(true)} style={{cursor: "pointer", textDecoration: "underline"}}>voir les raisons <FontAwesomeIcon icon={faList} /></div></>}</h3>
          </Col>}
        </Row>
        <Nav tabs>
        {!!auth?.user?.privileges?.includes(PRIVILEGE.OWN_GOAL) && <NavItem>
            <NavLink
              className={activeTab === constants.TAB_OBJECTIF ? "active" : ""}
              onClick={() => { setActiveTab(constants.TAB_OBJECTIF); }}>
              Objectif
            </NavLink>
          </NavItem>}
          {!!auth?.user?.privileges?.includes(PRIVILEGE.COMMISSIONS_BULLETIN) && <NavItem>
            <NavLink
              className={activeTab === constants.TAB_BULLETIN ? "active" : ""}
              onClick={() => { setActiveTab(constants.TAB_BULLETIN); }}>
              Bulletin
            </NavLink>
          </NavItem>}
        </Nav>
        <TabContent activeTab={activeTab}>
          {!!auth?.user?.privileges?.includes(PRIVILEGE.OWN_GOAL) && <TabPane tabId={constants.TAB_OBJECTIF}>
            <GoalCardContainer selectedUser={selectedUser} societeValue={societeValue} monthPickerValue={monthPickerValue} users={users.filter(e => !(filterUsers && !!auth?.user?.privileges?.includes(PRIVILEGE.OTHERS_COMMISSIONS)) || (e["worksatProjects"] && societeValue && (societeValue.id === "ALL" ? e["worksatProjects"].length : e["worksatProjects"].find(e => e.id === societeValue.id))))} loadingU={loadingU} />
          </TabPane>}
          {!!auth?.user?.privileges?.includes(PRIVILEGE.COMMISSIONS_BULLETIN) && <TabPane tabId={constants.TAB_BULLETIN}>
            <div className="fadeAnimation">
              <div className="moreSettings" style={{padding: 0, fontSize: "small"}}>
                <p onClick={() => setMoreSettings(e => !e)} style={{marginBottom: "5px"}}><FontAwesomeIcon icon={faAngleDoubleDown} className={`flipIcon${moreSettings ? " flipped" : ""}`} />&nbsp;&nbsp;Plus de paramètres</p>
              </div>
              <Collapse /*className="mb-2"*/ isOpen={moreSettings}>
                <Row>
                  <Col xs="12" sm="6">
                    <FormGroup>
                      <Label for="fromDatepicker">De :</Label>
                      <DatePicker id="fromDatepicker"
                        value={commissionsFrom}
                        dateFormat={constants.DP_DATE_FORMAT}
                        dayLabels={constants.DP_DAYS}
                        monthLabels={constants.DP_MONTHS}
                        weekStartsOn={constants.DP_WEEK_START}
                        // disabled={commissionsDatesLoading}
                        disabled={loadingCH}
                        style={(commissionsFrom && commissionsTo && moment(commissionsFrom) > moment(commissionsTo)) ? {backgroundColor: "tomato"} : {}}
                        onChange={e => setCommissionsFrom(e)} />
                    </FormGroup>
                  </Col>
                  <Col xs="12" sm="6">
                    <FormGroup>
                      <Label for="toDatepicker">À :</Label>
                      <DatePicker id="toDatepicker"
                        value={commissionsTo}
                        dateFormat={constants.DP_DATE_FORMAT}
                        dayLabels={constants.DP_DAYS}
                        monthLabels={constants.DP_MONTHS}
                        weekStartsOn={constants.DP_WEEK_START}
                        // disabled={commissionsDatesLoading}
                        disabled={loadingCH}
                        style={(commissionsFrom && commissionsTo && moment(commissionsFrom) > moment(commissionsTo)) ? {backgroundColor: "tomato"} : {}}
                        onChange={e => setCommissionsTo(e)} />
                    </FormGroup>
                  </Col>
                </Row>
                {false && <Row>
                  <Col xs="12" lg="6" className="fullFlexCenter">
                    <CustomInput type="switch" id="noCommission" name="noCommissionSwitch" label="Inclure les commissions nulles" disabled={loadingCH} checked={noCommissions} onChange={changeNoCommissionsHandle} />
                  </Col>
                  <Col xs="12" lg="6" className="fullFlexCenter">
                    <CustomInput type="switch" id="validatedCommission" name="validatedCommissionSwitch" label="Inclure les commissions totalement validées" disabled={loadingCH} checked={validatedCommissions} onChange={changeValidatedCommissionsHandle} />
                  </Col>
                </Row>}
                <Row>
                  <Col xs="12" className="fullFlexCenter mb-2">
                    <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
                      <Label for="CHFilters" className="fullEllipsis">Filtres : </Label>
                    </div>
                    <Select
                      id="CHFilters"
                      name="CHFilters"
                      className="reactselect"
                      classNamePrefix="react-select"
                      isMulti
                      value={CHFilters || []}
                      onChange={handleCHFiltersChange}
                      placeholder={'Chercher...'}
                      isClearable={false}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={false}
                      isDisabled={loadingCH}
                      options={CHFiltersOptions}
                      menuContainerStyle={{ zIndex: 9999999 }}
                      styles={{
                        multiValue: (styles, { data }) => {
                          return {
                            ...styles,
                            backgroundColor: data.color,
                          };
                        },
                        multiValueLabel: (styles, { data }) => ({
                          ...styles,
                          color: "white",
                        }),
                        multiValueRemove: (styles, { data }) => ({
                          ...styles,
                          color: "white",
                          ':hover': {
                            backgroundColor: data.color,
                            color: '#ddd',
                          },
                        }),
                      }}
                    />
                    <div className="commissionsCheckAllContainer ml-3">
                      <div className="commissionsCheckAllBtn" style={{color: "cadetblue"}} onClick={setDefaultCHFilters} ><FontAwesomeIcon icon={faCheckDouble} className="mr-1" />Standard</div>
                      <div className="commissionsCheckAllBtn" style={{color: "green"}} onClick={setAllCHFilters} ><FontAwesomeIcon icon={faListUl} className="mr-1" />Tout</div>
                    </div>
                  </Col>
                </Row>
              </Collapse>
              {loadingCH ? <Loading topSpace /> : <>
                <CommissionHistoryTable linesData={commissionsTableData} setTableData={setCommissionsTableData} setFilteredRows={setFilteredCommissionsRows} selectedRows={selectedRows} setSelectedRows={setSelectedRows} clearFilters={clearFilters} setClearFilters={setClearFilters} clearRowsKey={clearRowsKey} showProjectColumn={societeValue?.id === "ALL"} showComColumn={selectedUser?.id === "ALL"} users={users} formulas={formulas} formula_societe_defaults={formula_societe_defaults} societes={societes} formatFormula={formatFormula} />
                {!!(auth?.user?.privileges?.includes(PRIVILEGE.VALIDATE_COMMISSIONS) && selectedUser?.id !== "ALL") && <Container className="confirmDiv" fixed="down">
                  <Row className="justify-content-center">
                    <Col xs="11" md="7">
                      <FormGroup>
                        <Button
                          className={`btn ${blockCommission ? "btn-danger" : "btn-success"} confirmBtn`}
                          onClick={() => checkCHHandle(constants.VALIDATE_CHECK)}
                          disabled={disableSubmitCH/* || blockCommission*/ || blockCommissionLoading}
                          ><FontAwesomeIcon icon={disableSubmitCH || blockCommissionLoading ? faSpinner : faCheckCircle} className={disableSubmitCH || blockCommissionLoading ? "spinner" : ""} />&nbsp;&nbsp;{/*blockCommission && !blockCommissionLoading*/false ? (/*blockCommissionReasons || */"Commission bloquée pour ce commercial") : arList?.filter(e => !!e.accepted_table).length ? `Vérifier \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0${arList.filter(e => !!e.accepted_table).reduce((e, t) => e + (t.commission || 0) + (t.bonus_malus_table || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH` : `Vérifier`}</Button>
                      </FormGroup>
                    </Col>
                  </Row>
                </Container>}
              </>}
            </div>
          </TabPane>}
        </TabContent>
      </Container>
      
      <Modal isOpen={formulasModal} toggle={handleToggleFormulas} onClosed={modalClosedHandleFormulas} >
        <ModalHeader toggle={handleToggleFormulas}><FontAwesomeIcon icon={faCalculator} />&nbsp;&nbsp;Méthode de calcul de la commission</ModalHeader>
        <ModalBody>
          <Container className="linesConfirmationContainer" style={{padding: 0}}>
            {/* <Row>
              Choisissez la méthode de calcul de la commission de&nbsp;<b>{selectedUser?.LOGIN}</b>&nbsp;pour :
            </Row> */}
            <div className="fullFlexCenter">
              {!!selectedUser && <h4 className="title" style={{margin: 0}}><FontAwesomeIcon icon={faUser} />&nbsp;{selectedUser.LOGIN || ""}</h4>}
            </div>
            <Row className="justify-content-center">
              <Col xs="12" sm="12">
                <FormGroup>
                  <Label for="societeRead">Projet :</Label>
                  <Select
                    id="societeRead"
                    className="reactselect"
                    classNamePrefix="react-select"
                    value={societeFormulaValue ? {label: societeFormulaValue["LIBELE"], value: societeFormulaValue} : null}
                    onChange={handleSocieteFormulaChange}
                    placeholder={'Chercher par projet...'}
                    isClearable={false}
                    isLoading={loadingS}
                    loadingMessage={() => 'Chargement...'}
                    noOptionsMessage={() => 'pas de resultat'}
                    isSearchable={true}
                    labelKey='LIBELE'
                    options={societeOptionsWithNoAll}
                    filterOption={filterOptions}
                  />
                </FormGroup>
              </Col>
            </Row>
            {!!auth?.user?.privileges?.includes(PRIVILEGE.SEE_COMMISSIONS_FORMULAS) && <div className="changeFormulaContainer">
              <div className="formulaCollapseOpener" onClick={() => setUserFormulasOpen(e => !e)}>
                <div style={{fontFamily: "'Ultra', sans-serif", fontStyle: "italic", letterSpacing: "2px"}}><FontAwesomeIcon icon={faList} />&nbsp;Les méthodes de calcul pour&nbsp;<b>{societeFormulaValue?.LIBELE}</b></div>
                <FontAwesomeIcon icon={faAngleDown} className={`flipIcon${userFormulasOpen ? " flipped" : ""}`} />
              </div>
              <Collapse className="mt-2" isOpen={userFormulasOpen}>
                <div className="selectableList">
                  {comFormulas?.length ? comFormulas.map((e, key) => !!e?.formula ? <div className="selectableListItemNoAni" key={key}>
                    {/* <div className="selectableListHead"><span style={selectedFormula?.id === e.formula?.id ? {backgroundColor: "#62af42"} : {}}><FontAwesomeIcon icon={faCheck} style={{color: "white"}} /></span></div> */}
                    <div className="selectableListHead" style={{borderRight: "1px solid #eee", lineHeight: "100%"}}>{e.type ? betterTypeName(e.type) : "Tout type"}</div>
                    <div className="selectableListContent"><div className="selectableListContentDiv">{ e.formula?.content }</div></div>
                    {!!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_COMMISSIONS_FORMULAS) && <div className="selectableListTail" style={{borderLeft: "1px solid #eee"}}><FontAwesomeIcon icon={!!isDeleting.find(t => t === e.id) && !e.isFromSD && e.comId !== null ? faSpinner : faTrash} style={{color: "darkred", fontSize: "small", cursor: e.isFromSD || e.comId === null ? "default" : "pointer", opacity: e.isFromSD || e.comId === null ? .2 : 1}} className={!!isDeleting.find(t => t === e.id) && !e.isFromSD && e.comId !== null ? "spinner" : ""} title={e.isFromSD || e.comId === null ? "Veuillez la remplacer par une autre méthode en bas" : "Détacher"} onClick={() => deleteFIHandle(e)} /></div>}
                    <div className="cardSticker selectableListFloatingTitle" title={e.formula?.name}>({e.formula?.id || "-"}){e.formula?.name ? ` ${e.formula?.name}` : ""}</div>
                    {!!(e.isFromSD || e.comId === null) && <div className="cardSticker selectableListFloatingTitle" style={{backgroundColor: "green", right: "10px", left: "unset", maxWidth: "50%"}}>Standard</div>}
                  </div> : "-") : <div className="noTableData2" style={{borderTop: "1px solid #ddd"}}>Aucune méthode de calcul n'a été trouvée</div>}
                </div>
              </Collapse>
            </div>}
            {!!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_COMMISSIONS_FORMULAS) && <div className="changeFormulaContainer mt-3">
              <div className="formulaCollapseOpener" onClick={() => setIsChangeFormulaOpen(e => !e)}>
                <div style={{fontFamily: "'Ultra', sans-serif", fontStyle: "italic", letterSpacing: "2px"}}><FontAwesomeIcon icon={faEdit} />&nbsp;Changer les méthodes de calcul</div>
                <FontAwesomeIcon icon={faAngleDown} className={`flipIcon${isChangeFormulaOpen ? " flipped" : ""}`} />
              </div>
              <Collapse className="mt-2" style={{borderTop: "1px solid #ddd"}} isOpen={isChangeFormulaOpen}>
                <Row className="justify-content-center mt-2">
                  <Col xs="12" sm="12">
                    <FormGroup>
                      <div style={{display: "flex", justifyContent: "space-between"}}><Label for="societeWrite">Le(s) projet(s) :</Label>{!showSocieteWrite && <div>{societeFormulaCreateValue?.LIBELE || ""}&nbsp;<FontAwesomeIcon icon={faPen} style={{cursor: "pointer", fontSize: "small"}} onClick={() => setShowSocieteWrite(true)} /></div>}</div>
                      {!!showSocieteWrite && <Select
                        id="societeWrite"
                        className="reactselect"
                        classNamePrefix="react-select"
                        value={societeFormulaCreateValue ? {label: societeFormulaCreateValue["LIBELE"], value: societeFormulaCreateValue} : null}
                        onChange={handleSocieteFormulaCreateChange}
                        placeholder={'Chercher par projet...'}
                        isClearable={false}
                        isLoading={loadingS}
                        loadingMessage={() => 'Chargement...'}
                        noOptionsMessage={() => 'pas de resultat'}
                        isSearchable={true}
                        labelKey='LIBELE'
                        options={societeOptions}
                        filterOption={filterOptions}
                      />}
                    </FormGroup>
                  </Col>
                  <Col xs="12" sm="12">
                    <FormGroup>
                      <div style={{display: "flex", justifyContent: "space-between"}}><Label for="formulaTarget">Pour :</Label>{!showFormulaTarget && <div>{formulaTarget?.value !== "ALL" ? (selectedUser?.LOGIN || "") : ""}&nbsp;<FontAwesomeIcon icon={faPen} style={{cursor: "pointer", fontSize: "small"}} onClick={() => setShowFormulaTarget(true)} /></div>}</div>
                      {!!showFormulaTarget && <Select
                        id="formulaTarget"
                        className="reactselect"
                        classNamePrefix="react-select"
                        defaultValue={formulaTargetOptions[1]}
                        value={formulaTarget}
                        onChange={handleFormulaTargetChange}
                        isClearable={false}
                        loadingMessage={() => 'Chargement...'}
                        noOptionsMessage={() => 'pas de resultat'}
                        isSearchable={false}
                        options={formulaTargetOptions}
                      />}
                    </FormGroup>
                  </Col>
                  <Col xs="12" sm="12">
                    <FormGroup>
                      <div style={{display: "flex", justifyContent: "space-between"}}><Label for="typesvente">Le(s) type(s) de vente :</Label>{!showTypesVente ? <div>{typesVenteValues.length === typesVenteOptions.length ? "Tout type" : ""}&nbsp;<FontAwesomeIcon icon={faPen} style={{cursor: "pointer", fontSize: "small"}} onClick={() => setShowTypesVente(true)} /></div> : <div style={{cursor: "pointer", textDecoration: "underline"}} onClick={() => {setTypesVenteValues(typesVenteOptions); setShowTypesVente(false)}}><FontAwesomeIcon icon={faCheck} /> Cocher tout</div>}</div>
                      {!!showTypesVente && <Select
                        id="typesvente"
                        className="reactselect"
                        classNamePrefix="react-select"
                        isMulti
                        value={typesVenteValues?.map(e => ({label: e.label, value: e.value})) || []}
                        onChange={handleTypesVenteChange}
                        placeholder={'Chercher...'}
                        isClearable={true}
                        loadingMessage={() => 'Chargement...'}
                        noOptionsMessage={() => 'pas de resultat'}
                        isSearchable={true}
                        options={typesVenteOptions}
                      />}
                    </FormGroup>
                  </Col>
                </Row>
                {/* <Row className="linesConfirmationLines">
                  <Col xs="12" className="fullFlexCenter"><FontAwesomeIcon icon={faCircle} /></Col>
                </Row> */}
                <div className="selectableList">
                  {formulasData.map((e, key) => <div className="selectableListItem" onClick={() => {changeFormulaInstanceHandle(e.id); setFormulasModal(false);}} key={key}>
                    <div className="selectableListHead"><span style={selectedFormula?.id === e.id ? {backgroundColor: "#62af42"} : {}}><FontAwesomeIcon icon={faCheck} style={{color: "white"}} /></span></div>
                    <div className="selectableListContent"><div className="selectableListContentDiv">{ e.content }</div></div>
                    <div className="selectableListArrow"></div>
                    <div className="cardSticker selectableListFloatingTitle" title={e.name}>({e.id || "-"}){e.name ? ` ${e.name}` : ""}</div>
                    {!!formula_societe_defaults.find(t => t.formulaId === e.id) && <div className="cardSticker selectableListFloatingTitle" style={{backgroundColor: "green", right: "10px", left: "unset", maxWidth: "50%"}} title={`Standard ${formula_societe_defaults.filter(t => t.formulaId === e.id).filter(t => !!societes.find(n => n.id === t.societeId)).map(t => societes.find(n => n.id === t.societeId)?.LIBELE || "").join(" - ")}`}>{`Standard ${formula_societe_defaults.filter(t => t.formulaId === e.id).filter(t => !!societes.find(n => n.id === t.societeId)).map(t => societes.find(n => n.id === t.societeId)?.LIBELE || "").join(" - ")}`}</div>}
                  </div>)}
                  <div className="createFormulaContainer" onClick={() => {
                      // if(selectedFormula?.id !== 666)
                      //   setSelectedFormula({id: 666})
                    }}>
                    <div className="formulaCollapseOpener" onClick={() => setIsCreateFormulaOpen(e => !e)}>
                      <div style={{fontFamily: "'Ultra', sans-serif", fontStyle: "italic", letterSpacing: "2px"}}><FontAwesomeIcon icon={faFolderPlus} />&nbsp;Créer une nouvelle méthode de calcul</div>
                      <FontAwesomeIcon icon={faAngleDown} className={`flipIcon${isCreateFormulaOpen ? " flipped" : ""}`} />
                    </div>
                    <Collapse className="mt-2" isOpen={isCreateFormulaOpen}>
                      <div className="formulaEntriesContainer">
                        <Row style={{textAlign: "center", fontSize: "x-small", fontWeight: 600, color: "#666"}}>
                          <Col xs="4">Nombre</Col>
                          <Col xs="2">% / Forf.</Col>
                          <Col xs="5">Choix</Col>
                          <Col xs="1"></Col>
                        </Row>
                        {Object.entries(formulaEntries).map((e: any[], key, arr) => <><Row key={key}>
                          <Col xs="4">
                            <NumberFormat customInput={Input} allowNegative={true} placeholder="..." value={e[1].formulaNumber} suffix={e[1].formulaNumberOperator === 'p' ? "%" : " DH/u"} defaultValue={0} onFocus={focusHandler} onValueChange={t => setFormulaEntries(n => ({...n, [e[0]]: {...n[e[0]], formulaNumber: t?.value ? +t.value : 0}}))} className="text-center" />
                          </Col>
                          <Col xs="2">
                            <Select
                              name="reactselect"
                              className="reactselect reactselect-center"
                              classNamePrefix="react-select"
                              defaultValue={formulaNumberOperatorsOptions[0]}
                              value={e[1].formulaNumberOperator ? {label: e[1].formulaNumberOperator === 'p' ? "%" : "Forfait", value: e[1].formulaNumberOperator} : null}
                              onChange={t => {
                                setFormulaEntries(n => ({...n, [e[0]]: {...n[e[0]], formulaNumberOperator: t?.value || '', formulaNumber: t?.value === 'p' ? 0.5 : 200}}))
                              }}
                              isClearable={false}
                              loadingMessage={() => 'Chargement...'}
                              noOptionsMessage={() => ''}
                              isSearchable={false}
                              options={formulaNumberOperatorsOptions.filter(t => !arr.find((n: any) => n[1].formulaNumberOperator === t.value && n[1].formulaVar.id === e[1].formulaVar.id))}
                              components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }}
                            />
                          </Col>
                          <Col xs="5">
                            <Select
                              name="reactselect"
                              className="reactselect reactselect-center"
                              classNamePrefix="react-select"
                              value={e[1].formulaVar ? {label: e[1].formulaVar.description, value: e[1].formulaVar} : null}
                              onChange={t => {
                                setFormulaEntries(n => ({...n, [e[0]]: {...n[e[0]], formulaVar: t?.value || '', formulaNumber: Math.abs(n[e[0]].formulaNumber) * (t?.value?.id === constants.COMMISSION_EImpaye_ID ? -1 : 1)}}))
                              }}
                              placeholder={'...'}
                              isClearable={false}
                              loadingMessage={() => 'Chargement...'}
                              noOptionsMessage={() => 'pas de resultat'}
                              isSearchable={true}
                              labelKey='description'
                              options={formulaVarsOptions.filter(t => !arr.find((n: any) => n[1].formulaVar.id === t.value.id && n[1].formulaNumberOperator === e[1].formulaNumberOperator))}
                              components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }}
                            />
                          </Col>
                          <Col xs="1" className="fullFlexCenter">
                            <FontAwesomeIcon icon={faTimes} style={{color: "red", cursor: arr.length > 1 ? "pointer" : "default", opacity: arr.length > 1 ? 1 : .2}} onClick={() => (arr.length > 1) && setFormulaEntries(e => {
                                const temp = {...e};
                                delete temp[Number(key) + 1];
                                const arrTemp = Object.entries(temp);
                                const res = {};
                                for(let i = 0; i < arrTemp.length; i++)
                                  res[i + 1] = arrTemp[i][1]
                                // delete temp[Object.entries(temp).length];
                                return res
                              })} />
                          </Col>
                        </Row>
                        {!!(key < arr.length - 1) && <div className="fullFlexCenter">
                          <FontAwesomeIcon icon={faPlus} style={{color: "green"}} />
                        </div>}
                        </>)}
                        <div className="fullFlexCenter">
                          <div style={{cursor: "pointer", textDecoration: "underline", fontSize: "small", fontStyle: "italic"}} onClick={() => setFormulaEntries(e => ({...e, [Object.entries(e).length + 1]: {formulaNumber: .5, formulaVar: '', formulaNumberOperator: 'p'}}))}><FontAwesomeIcon icon={faPen} />&nbsp;Ajouter une ligne</div>
                        </div>
                      </div>
                      <Container>
                        <Row className="mt-2">
                          <Col xs="11" sm="12" className="fullFlexCenter">
                            <FormGroup style={{width: "100%"}}>
                              <div style={{display: "flex", justifyContent: "space-between"}}><Label for="formulaName">Nom :</Label><CustomInput type="switch" id="formulaNameAuthSwitch" label="Auto" checked={formulaNameAuto} onChange={() => setFormulaNameAuto(e => !e)} /></div>
                              <Input id="formulaName" placeholder="Nom de la méthode de calcul..." value={formulaName} onChange={formulaNameChangeHandler} />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row className="justify-content-center">
                          {/* <Col xs="11" md="5">
                            <Button
                              className="btn btn-info linesConfirmationBtn"
                              onClick={async () => await verifyFormulaAvailabilityHandle()}
                              title="Vérifier la disponibilité de cette méthode de calcul"
                              disabled={false}
                              ><FontAwesomeIcon icon={isVerifyingFA ? faSpinner : faSearch} className={isVerifyingFA ? "spinner" : ""} />&nbsp;&nbsp;Vérifier la Dispo.</Button>
                          </Col> */}
                          <Col xs="11" md="5">
                            <Button
                              className="btn btn-info linesConfirmationBtn"
                              onClick={() => addFormulaHandle(false)}
                              title="Ajouter sans changer la méthode de calcul"
                              disabled={disableSubmit}
                              ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faPlus} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Ajouter</Button>
                          </Col>
                          <Col xs="11" md="7">
                            <Button
                              className="btn btn-success linesConfirmationBtn"
                              onClick={() => addFormulaHandle(true)}
                              disabled={disableSubmit}
                              ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Ajouter et Choisir</Button>
                          </Col>
                        </Row>
                      </Container>
                    </Collapse>
                  </div>
                </div>
              </Collapse>
            </div>}
            <Row className="mt-2 floatingFormulaTags" style={{position: tagsArePinned ? "sticky" : "relative"}}>
              <FontAwesomeIcon icon={faThumbtack} className={`floatingFormulaTagsPin${tagsArePinned ? " floatingFormulaTagsPinned" : ""}`} title={tagsArePinned ? "Détacher" : "Épingler"} onClick={() => setTagsArePinned(e => !e)} />
              {formulaTags.map((e, key) => <Col xs="12" sm="6" style={{fontSize: "small", marginBottom: "2px"}} key={key}>
                {e.tag}&nbsp;<i className="formulaTagDescription" style={highlightTag === e.id ? {backgroundColor: "#0f08"} : {}}>{e.description}</i>
              </Col>)}
            </Row>
          </Container>
        </ModalBody>
      </Modal>
      <Modal isOpen={CHModal} toggle={handleToggleCH} onClosed={modalClosedHandleCH}>
        <ModalHeader toggle={handleToggleCH}><FontAwesomeIcon icon={faCheckCircle} />&nbsp;&nbsp;Confirmation Commission</ModalHeader>
        <ModalBody>
          <Container className="linesConfirmationContainer" style={{padding: 0}}>
            <Row>
              <Col xs="12">
                Êtes-vous sûr de vouloir passer&nbsp;<b>{arList.filter(e => !!e.accepted_table).reduce((e, t) => e + (t.commission || 0) + (t.bonus_malus_table || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</b>&nbsp;comme commission à <b>{selectedUser?.LOGIN || ""}</b>&nbsp;?
              </Col>
              <Col xs="12" className="fullFlexCenter">
                <b>{arList.filter(e => !!e.accepted_table).length}</b>&nbsp;lignes&nbsp;<b style={{color: "darkgreen"}}>acceptées</b>
              </Col>
              <Col xs="12" className="fullFlexCenter">
                <b>{arList.filter(e => !!e.rejected_table).length}</b>&nbsp;lignes&nbsp;<b style={{color: "darkred"}}>rejetées</b>
              </Col>
            </Row>
            {!!arList.filter(e => !!e.accepted_table).length && <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="bonusMalus">Bonus / Malus</Label>
                  <InputGroup className="quantityInputGroup">
                    <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative id="bonusMalus" placeholder="Bonus / Malus..." value={bonusMalusValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onValueChange={e => setBonusMalusValue(e.value ? +e.value : 0)} />
                    <InputGroupAddon addonType="append">
                      <InputGroupText>DH</InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>}
            {!!arList.filter(e => !!e.accepted_table).length && <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="commentCH">Commentaire</Label>
                  <Input id="commentCH" placeholder="Commentaire..." value={commentCHValue} onChange={commentCHChangeHandler} />
                </FormGroup>
              </Col>
            </Row>}
            <Row className="justify-content-center">
              <Col xs="11" md="7">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={() => checkCHHandle(constants.VALIDATE_CONFIRM)}
                  disabled={disableSubmitCH}
                  ><FontAwesomeIcon icon={disableSubmitCH ? faSpinner : faCheckCircle} className={disableSubmitCH ? "spinner" : ""} />&nbsp;&nbsp;{arList.filter(e => !!e.accepted_table).length ? "Passer Commission" : "Valider"}</Button>
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
      <CommissionBlockReasonsModal modal={blockCommissionReasonsModal} setModal={setBlockCommissionReasonsModal} reasons={blockCommissionReasons} />
    </>
  );
};

const mapStateToProps = (state: ICommissionReduxProps) => ({
  societe: state.societe,
  user: state.user,
  formula: state.formula,
  formula_instance: state.formula_instance,
  formula_societe_default: state.formula_societe_default,
  commission_history: state.commission_history,
  auth: state.auth
});

export default connect(mapStateToProps, { getSocietes, getUsers, addFormula, getFormulas, getFormula_instances, addOrEditFormula_instance, deleteFormula_instance, getFormula_societe_defaults, addOrEditFormula_societe_default, getCommission_histories, clearCommission_histories, addCommission_bulletin })(CommissionContainerComponent);
